import { FEATURE_APP_DETAILS } from '../constants';
import type { StockCarTypes } from '../types';
import { VehicleNameFormatter } from '../utils/analytics/VehicleNameFormatter';
import { VehicleStatusCalculator } from '../utils/analytics/VehicleStatusCalculator';

const getDataAttributes = (vehicle: StockCarTypes, formName: string, isTier3: boolean) => {
  const isAudiMake = VehicleNameFormatter.isAudiMake(vehicle);
  const modelNameWithoutYear = VehicleNameFormatter.removeYearFromModelName(
    vehicle?.titleText,
    isAudiMake,
  );

  const vehicleStatus = VehicleStatusCalculator.getVehicleStatus(vehicle);
  const vehicleSaleType = VehicleStatusCalculator.getSaleType(vehicle);
  const vehicleSaleOrderType = VehicleStatusCalculator.getSaleOrderType(vehicle);
  const orderStatusVehicle = VehicleStatusCalculator.getOrderStatus(vehicle);

  const msrp =
    vehicle?.carPrices?.find((toCheck) => toCheck.type === 'list')?.price?.valueAsText ||
    vehicle?.carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.valueAsText;

  const dealerPrice =
    vehicle?.carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.valueAsText || '';

  const modelPrice = isTier3 ? dealerPrice : msrp;
  const fuelType = vehicle?.manufacturerSpecificItems?.cdbItems?.find(
    (item) => item?.id === 'body-type',
  )?.value?.length
    ? vehicle?.manufacturerSpecificItems?.cdbItems?.find((item) => item?.id === 'fuel-type')?.value
    : 'null';

  const modalDataAttributes = {
    'data-digital-leads-form-form-name': formName,
    'data-digital-leads-form-form-type': 'lead',
    'data-digital-leads-form-form-data-model-of-interest-model-family':
      vehicle?.titleText || 'null',
    'data-digital-leads-form-form-data-preferred-dealer': vehicle?.dealer?.id || 'null',
    'data-digital-leads-vehicle-audi-code': vehicle?.code?.id || 'null',
    'data-digital-leads-vehicle-dealer-code': vehicle?.dealer?.id || 'null',
    'data-digital-leads-vehicle-dealer-name': vehicle?.dealer?.name || 'null',
    'data-digital-leads-vehicle-fuel-type': fuelType || 'null',
    'data-digital-leads-vehicle-inventory-type': vehicle?.cartypeText || 'null',
    'data-digital-leads-vehicle-model-code': vehicle?.model?.id?.code || 'null',
    'data-digital-leads-vehicle-model-name': modelNameWithoutYear || 'null',
    'data-digital-leads-vehicle-model-year': vehicle?.model?.salesModelyear || 'null',
    'data-digital-leads-vehicle-price': modelPrice || 'null',
    'data-digital-leads-vehicle-price-dealer': dealerPrice || 'null',
    'data-digital-leads-vehicle-sale-type': vehicleSaleType || 'null',
    'data-digital-leads-vehicle-sale-order-type': vehicleSaleOrderType || 'null',
    'data-digital-leads-vehicle-order-status': orderStatusVehicle || 'null',
    'data-digital-leads-vehicle-status': vehicleStatus || 'null',
    'data-digital-leads-vehicle-stock-number': vehicle?.commissionNumber || 'null',
    'data-digital-leads-vehicle-vin': vehicle?.vin || 'null',
    'data-digital-leads-feature-app-base-url': FEATURE_APP_DETAILS.baseUrl,
    'data-digital-leads-feature-app-id': FEATURE_APP_DETAILS.id,
    'data-digital-leads-feature-app-name': FEATURE_APP_DETAILS.name,
  };
  return modalDataAttributes;
};

export default getDataAttributes;
